module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "choose-platform"
    }
  }, [_c('ul', _vm._l((_vm.platformLists), function(item) {
    return _c('li', {
      class: {
        'current-platform': _vm.currentPlatform === item.platFormName
      },
      on: {
        "click": function($event) {
          return _vm.choosePlat(item.platFormName)
        }
      }
    }, [_c('img', {
      class: item.iconName,
      attrs: {
        "src": '/static/img/downloadNew/' + item.iconName + '.svg',
        "alt": ""
      }
    }), _vm._v(_vm._s(item.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f15263c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download/choosePlatform/ChoosePlatform.vue
// module id = 1305
// module chunks = 1